import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineExport, AiOutlineUser } from 'react-icons/ai';
import Menu from '../Menu';
import { useUser } from '@dofleini/security';
import AuthDropdown from '../AuthDropdown';
import UserAvatar from '../UserAvatar';

const UserDetails = ({ user }) => {
  return <div className={'mb-2'}>
    <span className="ant-typography block">
      <strong>
        {user.fullName}
      </strong>
    </span>
    <span className="ant-typography opacity-75 block">
      {user.email}
    </span>
  </div>;
};

const UserOption = ({ children, options, onClick, layout, register, requestAccess, ...rest }) => {
  const { user } = useUser();

  if (user)
    return (
      <Menu options={options} menuProps={{ selectable: false }} onClick={onClick}
        start={<UserDetails user={user}/>}
        placement="bottomRight">
        <div className={'cursor-pointer'}>
          {children}
        </div>
      </Menu>
    );

  return (
    <AuthDropdown register={register} requestAccess={requestAccess} layout={layout} {...rest}>
      {children}
    </AuthDropdown>
  );
};

export default memo(UserOption);

UserOption.propTypes = {
  children: PropTypes.any,
  layout: PropTypes.any,
  onClick: PropTypes.func,
  options: PropTypes.array,
  register: PropTypes.bool,
  requestAccess: PropTypes.bool
};

UserOption.defaultProps = {
  children: (<UserAvatar/>),
  options: [
    {
      divider: true
    },
    {
      title: 'profile',
      link: '/profile',
      icon: <AiOutlineUser/>,
    },
    {
      divider: true,

    },
    {
      className: 'mt-2',
      title: 'logout',
      action: 'LOGOUT',
      icon: <AiOutlineExport/>,
    }
  ],
  register: true,
  useCaptcha: false,
  requestAccess: true
};

UserDetails.propTypes = {
  user: PropTypes.object
};
